export default {
  namespace: 'mall',
  state: {},
  mutations: {},
  actions: {},
  modules: {},
};
